export default __webpack_public_path__ + "static/media/024-dog.55919a08.svg";